import { FArrangementTypesEnum } from '@spazious/dollhouse-shallow-graph';

import {
  FArrangementBoardroom,
  FArrangementBoardroomAttributes,
  FArrangementBoardroomSchema,
} from './FArrangementBoardroom.js';
import {
  FArrangementCabaret,
  FArrangementCabaretAttributes,
  FArrangementCabaretSchema,
} from './FArrangementCabaret.js';
import {
  FArrangementClassroom,
  FArrangementClassroomAttributes,
  FArrangementClassroomSchema,
} from './FArrangementClassroom.js';
import {
  FArrangementCocktail,
  FArrangementCocktailAttributes,
  FArrangementCocktailSchema,
} from './FArrangementCocktail.js';
import {
  FArrangementRound,
  FArrangementRoundAttributes,
  FArrangementRoundSchema,
} from './FArrangementRound.js';
import {
  FArrangementTheater,
  FArrangementTheaterAttributes,
  FArrangementTheaterSchema,
} from './FArrangementTheater.js';
import {
  FArrangementUshape,
  FArrangementUshapeAttributes,
  FArrangementUshapeSchema,
} from './FArrangementUshape.js';

export type FArrangementSchemas = {
  [FArrangementTypesEnum.Theater]: FArrangementTheaterSchema;
  [FArrangementTypesEnum.Round]: FArrangementRoundSchema;
  [FArrangementTypesEnum.Classroom]: FArrangementClassroomSchema;
  [FArrangementTypesEnum.Cabaret]: FArrangementCabaretSchema;
  [FArrangementTypesEnum.Cocktail]: FArrangementCocktailSchema;
  [FArrangementTypesEnum.Boardroom]: FArrangementBoardroomSchema;
  [FArrangementTypesEnum.Ushape]: FArrangementBoardroomSchema;
};

export type FArrangementAttributes = {
  [FArrangementTypesEnum.Theater]: FArrangementTheaterAttributes;
  [FArrangementTypesEnum.Round]: FArrangementRoundAttributes;
  [FArrangementTypesEnum.Classroom]: FArrangementClassroomAttributes;
  [FArrangementTypesEnum.Cabaret]: FArrangementCabaretAttributes;
  [FArrangementTypesEnum.Cocktail]: FArrangementCocktailSchema;
  [FArrangementTypesEnum.Boardroom]: FArrangementBoardroomAttributes;
  [FArrangementTypesEnum.Ushape]: FArrangementBoardroomAttributes;
};

export const FArrangementFactory = <TType extends FArrangementTypesEnum>(
  type: TType,
  schema: FArrangementSchemas[TType],
  initialValues?: FArrangementAttributes[TType]
) => {
  switch (type) {
    case FArrangementTypesEnum.Theater:
      return new FArrangementTheater(
        schema as FArrangementTheaterSchema,
        initialValues as FArrangementTheaterAttributes
      );
    case FArrangementTypesEnum.Round:
      return new FArrangementRound(
        schema as FArrangementRoundSchema,
        initialValues as FArrangementRoundAttributes
      );
    case FArrangementTypesEnum.Classroom:
      return new FArrangementClassroom(
        schema as FArrangementClassroomSchema,
        initialValues as FArrangementClassroomAttributes
      );
    case FArrangementTypesEnum.Cabaret:
      return new FArrangementCabaret(
        schema as FArrangementCabaretSchema,
        initialValues as FArrangementCabaretAttributes
      );
    case FArrangementTypesEnum.Cocktail:
      return new FArrangementCocktail(
        schema as FArrangementCocktailSchema,
        initialValues as FArrangementCocktailAttributes
      );
    case FArrangementTypesEnum.Boardroom:
      return new FArrangementBoardroom(
        schema as FArrangementBoardroomSchema,
        initialValues as FArrangementBoardroomAttributes
      );
    case FArrangementTypesEnum.Ushape:
      return new FArrangementUshape(
        schema as FArrangementUshapeSchema,
        initialValues as FArrangementUshapeAttributes
      );
    default:
      throw new Error(`Unknown FArrangement type: ${type}`);
  }
};
